import * as types from "./types";
import { initialState } from "./initialState";

export default function limitReducer(state = initialState, action) {
  switch (action.type) {

    case types.API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case types.ADD_PHASE:
      return {
        ...state,
        addphase: action.payload,
      };
    case types.ADD_TABLE:
      return {
        ...state,
        addtable: action.payload,
      };
    case types.GET_TABLE:
      return {
        ...state,
        tableList: action.payload,
      };

    case types.GET_PHASE:
      return {
        ...state,
        phaseList: action.payload,
      };

    case types.GET_PARA:
      return {
        ...state,
        paraList: action.payload,
      };

    case types.META_LIST:
      return {
        ...state,
        metaList: action.payload,
      };

    case types.ADD_PARA:
      return {
        ...state,
        addPara: action.payload,
      };

    case types.UPDATE_PARA:
      return {
        ...state,
        updatePara: action.payload,
      };

    case types.TEMPLATE_VIEW:
      return {
        ...state,
        templateView: action.payload,
      };

    case types.RESTORE_PARAMETER:
      return {
        ...state,
        restore: action.payload,
      };

    case types.DELETE_PARA:
      return {
        ...state,
        deleteProcess: action.payload,
      };
    case types.DELETE_PHASE:
      return {
        ...state,
        deletePhase: action.payload,
      };
    case types.DELETE_TABLE:
      return {
        ...state,
        deleteTable: action.payload,
      };

    case types.APPROVE_PARAMETER:
      return {
        ...state,
        approveParameter: action.payload,
      };
    case types.REORDER_COLUNM:
      return {
        ...state,
        orderCol: action.payload,
      };
    case types.REORDER_SHEET:
      return {
        ...state,
        orderSheet: action.payload,
      };

    default:
      return state;
  }
}
